var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0293 6.00313C7.48324 5.44805 6.74277 5.13623 5.9707 5.13623C5.19862 5.13623 4.45815 5.44805 3.9121 6.00313L1.85284 8.09662C1.30677 8.65193 1 9.40511 1 10.1904C1 10.9758 1.30677 11.729 1.85284 12.2843C2.3989 12.8396 3.13952 13.1516 3.91177 13.1516C4.68402 13.1516 5.42464 12.8396 5.9707 12.2843L7 11.2375",
    stroke: "#888888",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.96875 8.09767C6.5148 8.65275 7.25527 8.96457 8.02735 8.96457C8.79942 8.96457 9.53989 8.65275 10.0859 8.09767L12.1452 6.00418C12.6913 5.44886 12.998 4.69568 12.998 3.91034C12.998 3.12501 12.6913 2.37183 12.1452 1.81651C11.5991 1.26119 10.8585 0.949219 10.0863 0.949219C9.31403 0.949219 8.57341 1.26119 8.02735 1.81651L6.99805 2.86326",
    stroke: "#888888",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.0bca7fc1.svg";
export { ForwardRef as ReactComponent };